<template>
    <el-container class="el-container">
    <el-aside width="auto" ><common-aside/></el-aside>
    <el-container>
        <el-header  class="el-header"><common-head/></el-header>
        <el-main><router-view></router-view></el-main>
    </el-container>
    </el-container>
</template>
<script>
import CommonAside from '../components/CommonAside.vue';
import CommonHead from '../components/CommonHead.vue';
export default {
  components: { CommonAside },
    setup() {
        
    },
    components :{
        CommonHead,
        CommonAside
    }
}
</script>

<style scoped>
    .el-header{
        padding:0;
    }
    .el-container{
        padding: 0;
        margin: 0;
    }
</style>